import React, { useState } from 'react';

import Table from '../Table';

const SimpleTableGraph = ({ columnNames, rows, defaultSortColumn = 1, initialLength = 10, maxLength = 1000 }) => {
	const [expanded, setExpanded] = useState(false);
	return (
		<div className="listgraph">
			<Table
				selectable={false}
				loading={!rows.length}
				data={rows.slice(0, expanded ? maxLength : initialLength)}
				defaultSort={defaultSortColumn}
				defaultSortAsc={false}
				perPage={maxLength}
				fields={columnNames.map((item, index) => ({
					title: item,
					sortable: true,
					sort: (row) => row[index],
					formatter: (row) =>
						typeof row[index] === 'object' ? (
							<a href={row[index][1]} rel="noopener noreferrer" target="_blank">
								{row[index][0]}
							</a>
						) : (
							row[index]
						)
				}))}
			/>
			{rows.length <= initialLength || (
				<span className="list-expander" onClick={() => setExpanded((expanded) => !expanded)}>
					{expanded ? 'View less' : 'View more'}
				</span>
			)}
		</div>
	);
};

export default SimpleTableGraph;
